import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';
import { AdobeAnalyticsService, TrackAction, TrackState } from '@pfizer/newton-jetpack-utils';
import { environment } from '../../environments/environment';
import { ACTION } from './analytics-constants';
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    public translate: TranslateService,
    public analytics: AdobeAnalyticsService,
  ) { }


  public trackAction(pageName: string, linkname: string, data = {}) {
    if (Capacitor.getPlatform() === 'web') {
      this.runScript(pageName);
    } else {
      const payload: TrackAction = this.constructActionPayload(pageName, linkname, data);
      this.analytics.trackAction(payload);
    }
  }

  public trackState(pageName: string, state: string[] = []) {
    if (Capacitor.getPlatform() === 'web') {
      this.runScript(pageName);
    } else {
      const payload: TrackState = this.constructStatePayload(pageName, state);
      this.analytics.trackState(payload);
    }
  }

  protected constructStatePayload(pageName: string, state: string[]): TrackState {
    return {
      language: this.translate.currentLang,
      pagename: pageName,
      country: environment.country,
      sitesection: state[0] ? state[0] : '',
      subsection: state[1] ? state[1] : '',
      subsectionlevel2: state[2] ? state[2] : '',
      subsectionlevel3: state[3] ? state[3] : ''
    };
  }

  protected constructActionPayload(pageName: string, linkname: string, data = {}): TrackAction {
    return {
      linkname,
      pagename: pageName,
      country: environment.country,
      extraData: data,
      linktype: ACTION.LINK_TYPE,
    };
  }

  protected runScript(pageName) {
    const data = {
      pfAnalyticsAttrData: {
        pfPageLoad: {
          customPageName: pageName
        }
      }
    };
    if (window['s']) {
      window['s'].pageName = data.pfAnalyticsAttrData.pfPageLoad.customPageName;
      window['s'].t();
    }
  }
}
